module.exports = __webpack_public_path__ + "static/media/PotatoChips.f0abc07a.jpg";